import { Shimmer } from "@my-scoot/component-library-legacy";
import React from "react";
import ProcessingState from "ui/pages/MediaLibrary/components/VdoCipherVideoUploader/components/ProcessingState/ProcessingState";
import useVdoCipherVideoDetails from "utils/recordedContentUtils/useVdoCipherVideoDetails";
import styles from "./VdoCipherNormalVideo.module.css";

// VdoCipher hosted non DRM video player
const VdoCipherNormalVideo = ({ videoId }) => {
  const { loaded, embedUrl, isReady } = useVdoCipherVideoDetails({
    videoId,
  });

  if (!loaded) return <Shimmer wrapper_classname={styles.loader} />;

  if (!isReady) return <ProcessingState className={styles.processingState} />;

  return (
    <iframe
      className={styles.vdoCipherIframe}
      title={videoId}
      src={embedUrl}
      allow="encrypted-media"
      allowFullScreen
    />
  );
};

export default VdoCipherNormalVideo;
